<aside class="nav-panel" *ngIf="section" aria-label="Section details">
  <div class="nav-panel__header">
    <h2 class="nav-panel__title">{{ section.label }}</h2>
    <button
      type="button"
      class="nav-panel__close p-link"
      (click)="close()"
      aria-label="Close panel">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="nav-panel__section" *ngIf="shortcuts.length">
    <div class="nav-panel__section-label">Shortcuts</div>
    <ul class="nav-panel__shortcuts">
      <li *ngFor="let item of shortcuts">
        <a
          class="nav-panel__shortcut"
          [class.nav-panel__shortcut--active]="isShortcutActive(item)"
          href="#"
          [style.--nav-color]="navColor(item.bgColor)"
          (click)="onShortcutClick(item, $event)">
          <span class="nav-panel__shortcut-icon">
            <i [ngClass]="item.icon"></i>
          </span>
          <span class="nav-panel__shortcut-label">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</aside>
